import {
	getToken
} from '@/utils/auth'
export default {
	state: {
		token: getToken(),
		user: "", // 登录的用户
		showLogin: false, // 用于控制是否显示登录组件
		qqService:"3755463635"
	},
	getters: {
		getUser(state) {
			return state.user
		},
		getShowLogin(state) {
			return state.showLogin
		},
		getQQService(state){
			return state.qqService
		}
	},
	mutations: {
		setUser(state, data) {
			state.user = data;
		},
		setShowLogin(state, data) {
			state.showLogin = data;
		},
		setQQService(state, data) {
			state.qqService = data
		}
	},
	actions: {
		setUser({commit}, data) {
			commit('setUser', data);
		},
		setShowLogin({commit}, data) {
			commit('setShowLogin', data);
		},
		setQQService({commit},data){
			commit('setQQService',data)
		},
	}
}
